import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { ClickEventComponentNames } from 'features/analytics';
import { logButtonClick } from 'features/navigation/utils/analytics';
import { Pressable, StyleSheet } from 'react-native';

import { primitive } from 'styles/constants';

const BUTTON_SIZE = 44;

export const VideoReplayButton = ({ onReplay }: { onReplay: () => void }) => {
  return (
    <Pressable
      onPress={() => {
        logButtonClick({
          attributes: {
            component: ClickEventComponentNames.BUTTON,
            name: 'Replay SHP video',
          },
        });
        onReplay();
      }}
      style={styles.replayButton}
      accessibilityRole="button"
      accessibilityLabel="Replay video"
      aria-label="Replay video"
      hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
    >
      <MaterialIcons name="refresh" size={24} color={primitive.$bbqBrown} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  replayButton: {
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    borderRadius: 22,
    backgroundColor: primitive.$mayoEggWhite,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: primitive.$bbqBrown,
  },
});
